import React from 'react';
import { Hero } from '../components/site/Hero';
import { Positioning } from '../components/site/Positioning';
import { WhyNotATS } from '../components/site/WhyNotATS';
import { Scenarios } from '../components/site/Scenarios';
import { HowItWorks } from '../components/site/HowItWorks';
import { SessionTrace } from '../components/site/SessionTrace';
import { DecisionRecord } from '../components/site/DecisionRecord';
import { Pipeline } from '../components/site/Pipeline';
import { Library } from '../components/site/Library';
import { Candidates } from '../components/site/Candidates';
import { Compliance } from '../components/site/Compliance';
import { Evidence } from '../components/site/Evidence';
import { Contact } from '../components/site/Contact';
export function Home() {
  return <>
      <Hero data-id="element-460" data-mp="3kvtonnr76826" />
      <Positioning data-id="element-461" data-mp="3ku8rrrheud15" />
      <WhyNotATS data-id="element-462" data-mp="3kuqun6ykvpi1" />
      <Scenarios data-id="element-463" data-mp="3kxd1f4dna0z7" />
      <HowItWorks data-id="element-464" data-mp="3owvl5wtqc60g" />
      <SessionTrace data-id="element-465" data-mp="3owce5b5mb217" />
      <DecisionRecord data-id="element-466" data-mp="3ovu7rlp8r7fk" />
      <Pipeline data-id="element-467" data-mp="3ov2g2lyrltuk" />
      <Library data-id="element-468" data-mp="3oyq97k0ase8r" />
      <Candidates data-id="element-469" data-mp="30wjcmpo0ou4v" />
      <Compliance data-id="element-470" data-mp="30x1go8gx8cnc" />
      <Evidence data-id="element-471" data-mp="30vgnona991rl" />
      <Contact data-id="element-472" data-mp="30w04u1s2zm4k" />
    </>;
}